import { Page } from './page';
import { FeedbackSurveyResponse } from './feedbacksurvey';

export class Impression {
    id: string ;
    page: Page;
    targetId: string;
    referencePage: Page;
    dateCreated: Date;
    impressionType: ImpressionType;
    impressionStatus: ImpressionStatus;
    impressionLevel: ImpressionLevel;
    feedbackSurveyResponse: FeedbackSurveyResponse;
    trustLevel: TrustLevel;
    public constructor(init?:Partial<Impression>) {
        Object.assign(this, init);
    }
    getTrustString(): string {
        return this.trustLevel == TrustLevel.None 
            ? '' :  TrustLevel[this.trustLevel];
    }
}
export class Suggestion {
   id: string;
   impressions: Impression[];
   timeStamp: Date;
   userId: string;
   public constructor(init?:Partial<Suggestion>) {
    Object.assign(this, init);
}
}
export enum ImpressionType {
    None,
    Dashboard,
    Wordpress
}
export enum TrustLevel {
    None,
    Low, 
    Medium, 
    High,
}
export enum ImpressionStatus {
    None,
    Open, // Present in an active suggestion 
    Engaged, 
    Expired,  
    Declined, 
    Recycled, 
    Closed, // Has been explicitly marked closed, and will not be re-openned
}
export enum ImpressionLevel {
    None,
    Normal,
    Silver,
    Gold,
    Magenta,
}
